import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import SpreadsheetModelInputAttributeEditDto from './SpreadsheetModelInputAttributeEditDto';
import SpreadsheetModelOutputAttributeEditDto from './SpreadsheetModelOutputAttributeEditDto';

export class SpreadsheetModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {SpreadsheetModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {SpreadsheetModelOutputAttributeEditDto[]} */
		this.outputAttributes = null;
		/** @type {string} */
		this.model_zip_file = null;
		/** @type {string} */
		this.xscaler_file = null;
		/** @type {string} */
		this.yscaler_file = null;
		/** @type {string} */
		this.state_file = null;
	}

	/**
	 * @typedef {Object} _SpreadsheetModelEditDtoProps
	 * @property {SpreadsheetModelInputAttributeEditDto[]} inputAttributes
	 * @property {SpreadsheetModelOutputAttributeEditDto[]} outputAttributes
	 * @property {string} model_zip_file
	 * @property {string} xscaler_file
	 * @property {string} yscaler_file
	 * @property {string} state_file
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _SpreadsheetModelEditDtoProps} SpreadsheetModelEditDtoProps
	 */
	/**
	 *
	 * @param {SpreadsheetModelEditDtoProps} props
	 * @returns {SpreadsheetModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new SpreadsheetModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new SpreadsheetModelOutputAttributeEditDto().setup(d)) : [];
		this.model_zip_file = props.model_zip_file;
		this.xscaler_file = props.xscaler_file;
		this.yscaler_file = props.yscaler_file;
		this.state_file = props.state_file;
		return this;
	}
}

export default SpreadsheetModelEditDto;
